document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.journal-page-tabs-container .tab-name');
    const tabsContents = document.querySelectorAll('.journal-page-tabs-content-container .each-tab-content-container');

    if (tabs.length === 0 || tabsContents.length === 0) return;

    // ✅ Default state → All active
    tabs.forEach(tab => tab.classList.remove('active'));
    tabs[0].classList.add('active');

    tabsContents.forEach(content => content.classList.add('active'));

    tabs.forEach((eachTab, index) => {
        eachTab.addEventListener('click', () => {

            tabs.forEach(tab => tab.classList.remove('active'));
            eachTab.classList.add('active');

            // ✅ FIRST TAB = ALL
            if (index === 0) {
                tabsContents.forEach(content => content.classList.add('active'));
                return;
            }

            const clickedTabName = eachTab.dataset.tabName?.toLowerCase();

            tabsContents.forEach(eachTabContent => {
                const tabContainerName = eachTabContent.dataset.tabName?.toLowerCase();

                if (clickedTabName === tabContainerName) {
                    eachTabContent.classList.add('active');
                } else {
                    eachTabContent.classList.remove('active');
                }
            });
        });
    });
});